import { render, staticRenderFns } from "./BelgeTuruView.vue?vue&type=template&id=4fe37999&"
import script from "./BelgeTuruView.vue?vue&type=script&lang=js&"
export * from "./BelgeTuruView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports